import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue-pro'
import { CIcon } from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import api from "./plugins/axios";

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(VueSweetalert2)
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.config.globalProperties.$axios = api;

const baseUrl = process.env.VUE_APP_API_URL;

app.config.globalProperties.$baseUrl = baseUrl;

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
  });

app.mount('#app')
